import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";

const Home = () => System.import("@/components/Home");
const Login = () => System.import("@/components/Login");
const Welcome = () => System.import("@/components/Welcome");

const AplicacionEdit = () => System.import("@/components/aplicacion/AplicacionEdit");
const AplicacionList = () => System.import("@/components/aplicacion/AplicacionList");

const AplicacionVersionEdit = () => System.import("@/components/aplicacion_version/AplicacionVersionEdit");
const AplicacionVersionList = () => System.import("@/components/aplicacion_version/AplicacionVersionList");

const ContadorList = () => System.import("@/components/contador/ContadorList");
const ContadorEdit = () => System.import("@/components/contador/ContadorEdit");

const ContadorClienteEdit = () => System.import("@/components/contador_cliente/ContadorClienteEdit");
const ContadorClienteList = () => System.import("@/components/contador_cliente/ContadorClienteList");

const ContadorClienteDocumentoEdit = () => System.import("@/components/contador_cliente_documento/ContadorClienteDocumentoEdit");
const ContadorClienteDocumentoList = () => System.import("@/components/contador_cliente_documento/ContadorClienteDocumentoList");

const ContadorDocumentoList = () => System.import("@/components/contador_documento/ContadorDocumentoList");
const ContadorDocumentoEdit = () => System.import("@/components/contador_documento/ContadorDocumentoEdit");

const ContribuyenteEdit = () => System.import("@/components/contribuyente/ContribuyenteEdit");
const ContribuyenteList = () => System.import("@/components/contribuyente/ContribuyenteList");

const DashboardEdit = () => System.import("@/components/dashboard/DashboardEdit");
const DashboardList = () => System.import("@/components/dashboard/DashboardList");

const DeviceEdit = () => System.import("@/components/device/DeviceEdit");
const DeviceList = () => System.import("@/components/device/DeviceList");

const DocumentoEdit = () => System.import("@/components/documento/DocumentoEdit");
const DocumentoList = () => System.import("@/components/documento/DocumentoList");

const EntidadEdit = () => System.import("@/components/entidad/EntidadEdit");
const EntidadList = () => System.import("@/components/entidad/EntidadList");

const FacturaEdit = () => System.import("@/components/factura/FacturaEdit");
const FacturaList = () => System.import("@/components/factura/FacturaList");

const FeriadoList = () => System.import("@/components/feriado/FeriadoList");
const FeriadoEdit = () => System.import("@/components/feriado/FeriadoEdit");

const IvaTipoEdit = () => System.import("@/components/iva_tipo/IvaTipoEdit");
const IvaTipoList = () => System.import("@/components/iva_tipo/IvaTipoList");

const MenuEdit = () => System.import("@/components/menu/MenuEdit");
const MenuList = () => System.import("@/components/menu/MenuList");

const PaisList = () => System.import("@/components/pais/PaisList");
const PaisEdit = () => System.import("@/components/pais/PaisEdit");

const PerfilList = () => System.import("@/components/perfil/PerfilList");
const PerfilEdit = () => System.import("@/components/perfil/PerfilEdit");

const RubroEdit = () => System.import("@/components/rubro/RubroEdit");
const RubroList = () => System.import("@/components/rubro/RubroList");

const TimbradoEdit = () => System.import("@/components/timbrado/TimbradoEdit");
const TimbradoList = () => System.import("@/components/timbrado/TimbradoList");

const UsuarioEdit = () => System.import("@/components/usuario/UsuarioEdit");
const UsuarioList = () => System.import("@/components/usuario/UsuarioList");

const UsuarioRolEdit = () => System.import("@/components/usuario_rol/UsuarioRolEdit");
const UsuarioRolList = () => System.import("@/components/usuario_rol/UsuarioRolList");

const UsuarioRolMenuEdit = () => System.import("@/components/usuario_rol_menu/UsuarioRolMenuEdit");
const UsuarioRolMenuList = () => System.import("@/components/usuario_rol_menu/UsuarioRolMenuList");

const AreaEdit = () => System.import("@/components/area/AreaEdit");
const AreaList = () => System.import("@/components/area/AreaList");

const DepartamentoEdit = () => System.import("@/components/departamento/DepartamentoEdit");
const DepartamentoList = () => System.import("@/components/departamento/DepartamentoList");

const CiudadEdit = () => System.import("@/components/ciudad/CiudadEdit");
const CiudadList = () => System.import("@/components/ciudad/CiudadList");

const BarrioEdit = () => System.import("@/components/barrio/BarrioEdit");
const BarrioList = () => System.import("@/components/barrio/BarrioList");

const CategoriaEdit = () => System.import("@/components/categoria/CategoriaEdit");
const CategoriaList = () => System.import("@/components/categoria/CategoriaList");

const ClaseEdit = () => System.import("@/components/clase/ClaseEdit");
const ClaseList = () => System.import("@/components/clase/ClaseList");

const ZonaEdit = () => System.import("@/components/zona/ZonaEdit");
const ZonaList = () => System.import("@/components/zona/ZonaList");

const ClienteEdit = () => System.import("@/components/cliente/ClienteEdit");
const ClienteList = () => System.import("@/components/cliente/ClienteList");

const ClienteInmuebleEdit = () => System.import("@/components/cliente_inmueble/ClienteInmuebleEdit");
const ClienteInmuebleList = () => System.import("@/components/cliente_inmueble/ClienteInmuebleList");

const DeudaEdit = () => System.import("@/components/deuda/DeudaEdit");
const DeudaList = () => System.import("@/components/deuda/DeudaList");

const GastoConceptoEdit = () => System.import("@/components/gasto_concepto/GastoConceptoEdit");
const GastoConceptoList = () => System.import("@/components/gasto_concepto/GastoConceptoList");

const GastoEdit = () => System.import("@/components/gasto/GastoEdit");
const GastoList = () => System.import("@/components/gasto/GastoList");

const EmpresaEdit = () => System.import("@/components/empresa/EmpresaEdit");
const EmpresaList = () => System.import("@/components/empresa/EmpresaList");

const AlumnoEdit = () => System.import("@/components/alumno/AlumnoEdit");
const AlumnoList = () => System.import("@/components/alumno/AlumnoList");

const CursoEdit = () => System.import("@/components/curso/CursoEdit");
const CursoList = () => System.import("@/components/curso/CursoList");

const CuotaEdit = () => System.import("@/components/cuota/CuotaEdit");
const CuotaList = () => System.import("@/components/cuota/CuotaList2");
const CuotaGenerate = () => System.import("@/components/cuota/CuotaGenerate");

const ReportePagoList = () => System.import("@/components/reportes/ReportePagoList");

const ReportePago = () => System.import("@/components/reportes/ReportePago");
const ReporteDeuda = () => System.import("@/components/reportes/ReporteDeuda");
const ReporteFactura = () => System.import("@/components/reportes/ReporteFactura");

const CotizacionList = () => System.import("@/components/cotizacion/CotizacionList");
const CotizacionEdit = () => System.import("@/components/cotizacion/CotizacionEdit");


Vue.use(Router);

const childrenHome = [{
        path: "",
        name: "Welcome",
        component: Welcome,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "aplicacion-list",
        name: "AplicacionList",
        component: AplicacionList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "aplicacion-edit",
        name: "AplicacionEdit",
        component: AplicacionEdit,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "aplicacionversion-list",
        name: "AplicacionVersionList",
        component: AplicacionVersionList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "aplicacionversion-edit",
        name: "AplicacionVersionEdit",
        component: AplicacionVersionEdit,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contador-list",
        name: "ContadorList",
        component: ContadorList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contador-edit",
        name: "ContadorEdit",
        props: true,
        component: ContadorEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contadorcliente-edit",
        name: "ContadorClienteEdit",
        props: true,
        component: ContadorClienteEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contadorcliente-list",
        name: "ContadorClienteList",
        component: ContadorClienteList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contadorclientedocumento-edit",
        name: "ContadorClienteDocumentoEdit",
        props: true,
        component: ContadorClienteDocumentoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contadorclientedocumento-list",
        name: "ContadorClienteDocumentoList",
        component: ContadorClienteDocumentoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contadordocumento-edit",
        name: "ContadorDocumentoEdit",
        props: true,
        component: ContadorDocumentoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contadordocumento-list",
        name: "ContadorDocumentoList",
        component: ContadorDocumentoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contribuyente-edit",
        name: "ContribuyenteEdit",
        props: true,
        component: ContribuyenteEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "contribuyente-list",
        name: "ContribuyenteList",
        component: ContribuyenteList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "dashboard-edit",
        name: "DashboardEdit",
        props: true,
        component: DashboardEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "dashboard-list",
        name: "DashboardList",
        component: DashboardList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "device-edit",
        name: "DeviceEdit",
        props: true,
        component: DeviceEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "device-list",
        name: "DeviceList",
        component: DeviceList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: 'factura-edit',
        name: 'FacturaEdit',
        props: true,
        component: FacturaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: 'factura-list',
        name: 'FacturaList',
        component: FacturaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "documento-edit",
        name: "DocumentoEdit",
        props: true,
        component: DocumentoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "documento-list",
        name: "DocumentoList",
        component: DocumentoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "entidad-edit",
        name: "EntidadEdit",
        props: true,
        component: EntidadEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "entidad-list",
        name: "EntidadList",
        component: EntidadList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "feriado-list",
        name: "FeriadoList",
        component: FeriadoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "feriado-edit",
        name: "FeriadoEdit",
        component: FeriadoEdit,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ivatipo-edit",
        name: "IvaTipoEdit",
        props: true,
        component: IvaTipoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ivatipo-list",
        name: "IvaTipoList",
        component: IvaTipoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "menu-edit",
        name: "MenuEdit",
        props: true,
        component: MenuEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "menu-list",
        name: "MenuList",
        component: MenuList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "pais-list",
        name: "PaisList",
        component: PaisList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "pais-edit",
        name: "PaisEdit",
        component: PaisEdit,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "perfil-list",
        name: "PerfilList",
        component: PerfilList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "perfil-edit",
        name: "PerfilEdit",
        component: PerfilEdit,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "rubro-edit",
        name: "RubroEdit",
        props: true,
        component: RubroEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "rubro-list",
        name: "RubroList",
        component: RubroList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "timbrado-edit",
        name: "TimbradoEdit",
        props: true,
        component: TimbradoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "timbrado-list",
        name: "TimbradoList",
        component: TimbradoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "usuario-edit",
        name: "UsuarioEdit",
        props: true,
        component: UsuarioEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "usuario-list",
        name: "UsuarioList",
        component: UsuarioList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "usuariorol-edit",
        name: "UsuarioRolEdit",
        props: true,
        component: UsuarioRolEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "usuariorol-list",
        name: "UsuarioRolList",
        component: UsuarioRolList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "usuariorolmenu-edit",
        name: "UsuarioRolMenuEdit",
        props: true,
        component: UsuarioRolMenuEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "usuariorolmenu-list",
        name: "UsuarioRolMenuList",
        component: UsuarioRolMenuList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "area-edit",
        name: "AreaEdit",
        props: true,
        component: AreaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "area-list",
        name: "AreaList",
        component: AreaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "departamento-edit",
        name: "DepartamentoEdit",
        props: true,
        component: DepartamentoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "departamento-list",
        name: "DepartamentoList",
        component: DepartamentoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ciudad-edit",
        name: "CiudadEdit",
        props: true,
        component: CiudadEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ciudad-list",
        name: "CiudadList",
        component: CiudadList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "barrio-edit",
        name: "BarrioEdit",
        props: true,
        component: BarrioEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "barrio-list",
        name: "BarrioList",
        component: BarrioList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "categoria-edit",
        name: "CategoriaEdit",
        props: true,
        component: CategoriaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "categoria-list",
        name: "CategoriaList",
        component: CategoriaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "clase-edit",
        name: "ClaseEdit",
        props: true,
        component: ClaseEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "clase-list",
        name: "ClaseList",
        component: ClaseList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "zona-edit",
        name: "ZonaEdit",
        props: true,
        component: ZonaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "zona-list",
        name: "ZonaList",
        component: ZonaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cliente-edit",
        name: "ClienteEdit",
        props: true,
        component: ClienteEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cliente-list",
        name: "ClienteList",
        component: ClienteList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "clienteinmueble-edit",
        name: "ClienteInmuebleEdit",
        props: true,
        component: ClienteInmuebleEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "clienteinmueble-list",
        name: "ClienteInmuebleList",
        component: ClienteInmuebleList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "deuda-edit",
        name: "DeudaEdit",
        props: true,
        component: DeudaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "deuda-list",
        name: "DeudaList",
        component: DeudaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "gastoconcepto-edit",
        name: "GastoConceptoEdit",
        props: true,
        component: GastoConceptoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "gastoconcepto-list",
        name: "GastoConceptoList",
        component: GastoConceptoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "gasto-edit",
        name: "GastoEdit",
        props: true,
        component: GastoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "gasto-list",
        name: "GastoList",
        component: GastoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "empresa-edit",
        name: "EmpresaEdit",
        props: true,
        component: EmpresaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "empresa-list",
        name: "EmpresaList",
        component: EmpresaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "alumno-edit",
        name: "AlumnoEdit",
        props: true,
        component: AlumnoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "alumno-list",
        name: "AlumnoList",
        component: AlumnoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "curso-edit",
        name: "CursoEdit",
        props: true,
        component: CursoEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "curso-list",
        name: "CursoList",
        component: CursoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cuota-edit",
        name: "CuotaEdit",
        props: true,
        component: CuotaEdit,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cuota-list",
        name: "CuotaList",
        component: CuotaList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cuota-generate",
        name: "CuotaGenerate",
        component: CuotaGenerate,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "reportepago-list",
        name: "ReportePagoList",
        component: ReportePagoList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ReportePago",
        name: "ReportePago",
        component: ReportePago,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ReporteDeuda",
        name: "ReporteDeuda",
        component: ReporteDeuda,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "ReporteFactura",
        name: "ReporteFactura",
        component: ReporteFactura,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cotizacion-list",
        name: "CotizacionList",
        component: CotizacionList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "cotizacion-edit",
        name: "CotizacionEdit",
        props: true,
        component: CotizacionEdit,
        meta: {
            requiresAuth: true
        }
    }




];

const routes = [{
        path: "/",
        // name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        },
        children: childrenHome
    },
    {
        path: "/login",
        name: "Login",
        component: Login
    },
    // todas las rutas que no existan.
    {
        path: "*",
        redirect: "/"
    }
];

const router = new Router({ mode: 'history', routes: routes });

router.beforeEach((to, from, next) => {
    // check to see if route has auth guard
    if (to.matched.some(rec => rec.meta.requiresAuth)) {
        if (!window.localStorage.getItem("usuario")) {
            next({
                name: "Login"
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    //console.log(to, from)
    //NProgress.start()
    if (to.name) {
        // Start the route progress bar.
        NProgress.start();
    }
    next();
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js